
import React from "react";
import { Button, Modal, Type, Utility } from "mesh-component-library";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";

type LegalInformationModalProps = {
    active?: boolean;
    primaryButton?: {
        testId: string;
        onClick: () => void;
    };
    closeButton?: {
        testId: string;
        onClick: () => void;
    };
}

export const LegalInformationModal = ({
    active,
    primaryButton,
    closeButton
} : LegalInformationModalProps) => {
    const getTranslatedText = useLocale();
    return (
        <Modal hideTrigger isActive={active} isFlushMobile onClose={closeButton.onClick}>
            <Modal.Header
                title={
                    <Type variant="inherit" weight="bold">
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION)}
                    </Type>
                }
                hasCloseButton={true}
                isInverse
            >
            </Modal.Header>
            <Modal.Body variant="cool-gray">
                <Utility.Div
                    utils={{ hrLeft: "md", hrRight: "md", vrTop: "md", vrBottom: "md" }}
                    className="legal-info-content"
                >
                    <Type variant="dark" size="lg" lineHeight="lg" element="ol">
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION_STATEMENT)}
                    </Type>
                    <Type variant="dark" size="lg" lineHeight="lg" element="li" utils={{ hrLeft : "md", vrTop: "md" }}>
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION_STATEMENT_FIRST)}
                    </Type>
                    <Type variant="dark" size="lg" lineHeight="lg" element="li" utils={{ hrLeft : "md" }}>
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION_STATEMENT_SECOND)}
                    </Type>
                    <Type variant="dark" size="lg" lineHeight="lg" element="li" utils={{ hrLeft : "md" }}>
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION_STATEMENT_THIRD)}
                    </Type>
                    <Type variant="dark" size="lg" lineHeight="lg" element="li" utils={{ hrLeft : "md" }}>
                        {getTranslatedText(TRANSLATION_CONSTANTS.LEGAL_INFORMATION_STATEMENT_FOURTH)}
                    </Type>
                </Utility.Div>
                <Utility.Div utils={{ fullWidth: true }} className="legal-info-footer">
                    <Button
                        size='lg'
                        isPrimary
                        shape="pill"
                        onClick={primaryButton.onClick}
                        utils={{ fullWidth: true, vrBottom: "md" }}
                        data-testid={primaryButton.testId}
                    >
                        {getTranslatedText(TRANSLATION_CONSTANTS.OK_LOWERCASE)}
                    </Button>
                </Utility.Div>
            </Modal.Body>
        </Modal>
    );
};